import constants from '@/Constants';
import { useLocation, useParams } from 'react-router-dom';

import { ReportDefault } from './ReportDefault';
import { ReportFoco } from './ReportFoco';
import { ReportFormularyQuestion } from './ReportFormularyQuestion';
import { ReportGencau } from './ReportGencau';
import { ReportGoiasa } from './ReportGoiasa';
import { ReportIzu } from './ReportIzu';
import { ReportMacatuba } from './Reportmacatuba';
import { ReportMichelinfleet } from './ReportMichelinfleet';
import { ReportNovorumo } from './ReportNovorumo';
import { ReportOmni } from './ReportOmni';
import { ReportRrembalagens } from './ReportRrembalagens';
import { ReportSESRJ } from './ReportSesrj';
import { ReportSESRJDashboard } from './ReportSesrjDashboard';
import { ReportTopico } from './ReportTopico';

export const PdfReport: React.FC = () => {
  const { reportId, workspaceSlug, token } = useParams<{
    reportId: string;
    workspaceSlug: string;
    token: string;
  }>();

  const { pathname } = useLocation();

  if (token !== constants.REPORTS_FUNCTION_AUTHORIZATION_TOKEN)
    return <div>Não Autorizado</div>;

  if (pathname.includes('formulary_questions')) {
    return (
      <ReportFormularyQuestion
        reportId={reportId}
        workspaceSlug={workspaceSlug}
      />
    );
  }

  if (workspaceSlug.includes('macatuba')) {
    return <ReportMacatuba reportId={reportId} workspaceSlug="macatuba" />;
  }

  switch (workspaceSlug) {
    case 'goiasa': {
      return <ReportGoiasa reportId={reportId} workspaceSlug={workspaceSlug} />;
    }

    case 'gencau': {
      return <ReportGencau reportId={reportId} workspaceSlug={workspaceSlug} />;
    }

    case 'michelinfleet': {
      return (
        <ReportMichelinfleet
          reportId={reportId}
          workspaceSlug={workspaceSlug}
        />
      );
    }

    case 'novorumo': {
      return (
        <ReportNovorumo reportId={reportId} workspaceSlug={workspaceSlug} />
      );
    }

    case 'rrembalagens': {
      return (
        <ReportRrembalagens reportId={reportId} workspaceSlug={workspaceSlug} />
      );
    }

    case 'sesrj': {
      return <ReportSESRJ reportId={reportId} workspaceSlug={workspaceSlug} />;
    }

    case 'pdf_dashboard_sesrj': {
      return (
        <ReportSESRJDashboard
          reportId={reportId}
          workspaceSlug={workspaceSlug}
        />
      );
    }

    case 'topico': {
      return <ReportTopico reportId={reportId} workspaceSlug={workspaceSlug} />;
    }

    case 'omni': {
      return <ReportOmni reportId={reportId} />;
    }

    case 'foco': {
      return <ReportFoco reportId={reportId} workspaceSlug={workspaceSlug} />;
    }
    
    case 'focohomolog': {
      return <ReportFoco reportId={reportId} workspaceSlug={workspaceSlug} />;
    }

    case 'izujapanese': {
      return <ReportIzu reportId={reportId} workspaceSlug={workspaceSlug} />;
    }

    default: {
      return (
        <ReportDefault reportId={reportId} workspaceSlug={workspaceSlug} />
      );
    }
  }
};
